/**
 * @file     CookiePreferencesButton.tsx
 * @purpose  Reopens the cookie preferences panel from anywhere (site footer,
 *           cookie policy). Unstyled so each host supplies its own look.
 */
'use client';

import type { ReactNode } from 'react';
import { openCookiePreferences } from '@/services/analytics/consentRuntime';

interface CookiePreferencesButtonProps {
  className?: string;
  children: ReactNode;
}

export function CookiePreferencesButton({ className, children }: CookiePreferencesButtonProps) {
  return (
    <button type="button" className={className} onClick={openCookiePreferences} aria-haspopup="dialog">
      {children}
    </button>
  );
}
